<script setup>
// --------------------------------- Imports -------------------------------- //

// ---------------------------------- Props --------------------------------- //
const props = defineProps({
  columnConfig: {
    type: Object,
    default: () => ({}),
  },
  componentConfig: {
    type: Object,
    default: () => ({}),
  },
  filterConfig: {
    type: Object,
    default: () => ({}),
  },
  operatorConfig: {
    type: Object,
    default: () => ({}),
  },
  formData: {
    type: Object,
    default: null,
  },
});
// ---------------------------------- Emits --------------------------------- //

// ---------------------------- Injects/Provides ---------------------------- //

// ----------------------- Variables - Pinia - consts ----------------------- //

// --------------------- Variables - Pinia - storeToRefs -------------------- //

// ------------------- Variables - Local - consts and lets ------------------ //

// ------------------------ Variables - Local - refs ------------------------ //

// ---------------------- Variables - Local - reactives --------------------- //

// --------------------------- Computed properties -------------------------- //

// -------------------------------- Functions ------------------------------- //

// -------------------------------- Watchers -------------------------------- //

// ----------------------------- Lifecycle Hooks ---------------------------- //
// console.log('Between Input Date Operator Component Loaded', props);
</script>

<template>
  <div class="col-span-12 flex gap-2">
    <DateTimeElement
      :options="{
        teleport: false,
        maxDate: (props.formData || props.filterConfig).operator_value_max ? new Date((props.formData || props.filterConfig).operator_value_max).toJSON().slice(0, 10) : null,
        ...componentConfig.options.min_options,
      }"
      name="operator_value_min"
      :default="filterConfig?.operator_value_min || null"
      rules="required"
      :messages="{ required: 'Start Date field is required' }"
    />
    <DateTimeElement
      :options="{
        teleport: false,
        minDate: (props.formData || props.filterConfig).operator_value_min ? new Date((props.formData || props.filterConfig).operator_value_min) : null,
        ...componentConfig.options.max_options,
      }"
      name="operator_value_max"
      :default="filterConfig?.operator_value_max || null"
      rules="required"
      :messages="{ required: 'End Date field is required' }"
    />
  </div>
</template>
